import { ScenarioName, STEP_PATHS } from './constants';
import { stepAssetGroupWizardConfig, stepCampaignSettingsWizardConfig } from '../steps';

const STEP_INFOS = {
  [STEP_PATHS.CAMPAIGN_SETTINGS]: stepCampaignSettingsWizardConfig,
  [STEP_PATHS.ASSET_GROUP]: stepAssetGroupWizardConfig,
};

const applyCommonSettingsPageSettings = stepInfo => ({
  ...stepInfo,
  hideStepHeader: true,
});

// Scenarios
// I. Creation
//   1. Campaign creation
//   2. Asset group
// II. Settings
//   1. Campaign settings
//   2. Asset group settings

const PERF_MAX_CAMPAIGN_CREATION = {
  scenarioName: ScenarioName.PerformanceMaxCampaignCreation,
  isEditing: false,
  stepList: [
    STEP_INFOS[STEP_PATHS.CAMPAIGN_SETTINGS],
    STEP_INFOS[STEP_PATHS.ASSET_GROUP],
  ],
};

const PERF_MAX_ASSET_GROUP_CREATION = {
  scenarioName: ScenarioName.PerformanceMaxAssetGroupCreation,
  isEditing: false,
  isCenteredLayout: true,
  stepList: [
    STEP_INFOS[STEP_PATHS.ASSET_GROUP],
  ],
};

const PERF_MAX_CAMPAIGN_SETTINGS = {
  scenarioName: ScenarioName.PerformanceMaxCampaignSettings,
  isEditing: true,
  stepList: [
    applyCommonSettingsPageSettings(STEP_INFOS[STEP_PATHS.CAMPAIGN_SETTINGS]),
  ],
};

const PERF_MAX_ASSET_GROUP_SETTINGS = {
  scenarioName: ScenarioName.PerformanceMaxAssetGroupSettings,
  isEditing: true,
  isCenteredLayout: true,
  stepList: [
    applyCommonSettingsPageSettings(STEP_INFOS[STEP_PATHS.ASSET_GROUP]),
  ],
};

export const PERF_MAX_CAMPAIGN_CRUD_SCENARIOS = {
  PERF_MAX_CAMPAIGN_CREATION,
  PERF_MAX_ASSET_GROUP_CREATION,
  PERF_MAX_CAMPAIGN_SETTINGS,
  PERF_MAX_ASSET_GROUP_SETTINGS,
};
